import { render } from "./featuredPage.vue?vue&type=template&id=11d987fe"
import script from "./featuredPage.vue?vue&type=script&lang=js"
export * from "./featuredPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__